import { gql, useQuery } from '@apollo/client';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';

const useRestrictionMessages = (skip?: boolean) => {
    const { store, language } = useStoreAndLanguageParams();

    const { data, loading, error } = useQuery<{
        productOrderRestrictionsForStore: {
            id: string;
            messageDE: string;
            messageEN: string;
            messageFR: string;
            messageIT: string;
        }[];
    }>(
        gql`
            query productOrderRestrictionsForStore($store: ID!) {
                productOrderRestrictionsForStore(store: $store) {
                    id
                    messageDE
                    messageEN
                    messageFR
                    messageIT
                }
            }
        `,
        {
            variables: {
                store,
            },
            fetchPolicy: 'cache-first',
            skip,
        }
    );

    if (error) {
        throw error;
    }

    const messages = data?.productOrderRestrictionsForStore.map(item => ({
        id: item.id,
        message: item[`message${language.toUpperCase()}` as keyof typeof item],
    }));

    return { messages, loading };
};

export default useRestrictionMessages;
